import { handleAxiosError } from "../utils/errorHandler";
import axiosInstance from "./axiosInstance";

export const fetchNavodUrl = async () => {
  try {
    const response = await axiosInstance.get(`/api/config/navod`);

    return { success: true, url: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při získávání URL návodu"
    );
    return { success: false, status, message };
  }
};

export const uploadNavodPdf = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axiosInstance.post(
      "/api/config/navod/upload",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return { success: true, message: response.data };
  } catch (error) {
    console.error(error);
    return { success: false, message: "Chyba při nahrávání souboru." };
  }
};

export const uploadAktualitaPdf = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axiosInstance.post(
      "/api/config/aktualita/upload",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return { success: true, message: response.data };
  } catch (error) {
    console.error(error);
    return { success: false, message: "Chyba při nahrávání souboru." };
  }
};

export const checkNavodExists = async () => {
  try {
    const response = await axiosInstance.get(`/api/config/navod`, {
      responseType: "blob",
      validateStatus: () => true, // umožní zachytit 404 jako validní odpověď
    });

    if (response.status === 200) {
      return { success: true };
    }

    if (response.status === 404) {
      return {
        success: false,
        status: 404,
        message: "Návod není nastaven v konfiguraci",
      };
    }

    return {
      success: false,
      status: response.status,
      message: "Chyba při získávání návodu",
    };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při získávání návodu"
    );
    return { success: false, status, message };
  }
};
